export default __webpack_public_path__ + "static/media/error.725fa53d.webp";